<section class="challenge-section py-5" style="background: #f5f8fc;">
    <div class="container">
        <!-- Headline mit Icon -->
        <div class="row justify-content-center mb-4">
            <div class="col-lg-8">
                <div class="d-flex flex-column align-items-center">
          <span class="challenge-icon d-flex align-items-center justify-content-center rounded-circle mb-3 shadow" style="background: linear-gradient(135deg,#ef4444 40%,#fbbf24 100%); width:70px; height:70px;">
            <i class="fa fa-exclamation-triangle text-white fs-2"></i>
          </span>
                    <h2 class="fw-bold mb-2 text-center display-6" style="letter-spacing:0.5px;">
                        Die Herausforderung: <span class="text-danger">Datenrecherche</span> kostet Zeit, Geld – und Nerven
                    </h2>
                </div>
            </div>
        </div>
        <!-- Storyline Card -->
        <div class="row justify-content-center mb-4">
            <div class="col-lg-9">
                <div class="card shadow-lg border-0 px-0 py-4 problem-card-gradient" style="border-radius:2rem;">
                    <div class="row g-0 align-items-center">
                        <!-- Optional: Illustration, z.B. ein SVG/PNG auf der linken Seite -->
                        <div class="col-md-4 d-none d-md-flex justify-content-center">
                            <img src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f50d.svg"
                                 alt="Recherche Illustration" style="max-width:120px; filter:drop-shadow(0 2px 8px #b4caf4);">
                        </div>
                        <div class="col-md-8">
                            <div class="card-body px-4">
                                <p class="lead mb-4" style="font-size:1.18rem;">
                                    <strong>Stellen Sie sich vor:</strong> Sie möchten eine Marketingkampagne starten, neue Kunden gewinnen oder gezielt Unternehmen in einer bestimmten Branche kontaktieren.
                                    <br><span class="text-secondary">Was folgt, ist meist mühsame Recherche:</span>
                                </p>

                                <!-- Moderner Stepper -->
                                <div class="stepper-container mb-4">
                                    <div class="stepper-line"></div>
                                    <ul class="list-unstyled p-0 m-0">
                                        <li class="stepper-item">
                                            <span class="step-circle bg-primary"><i class="fa fa-globe"></i></span>
                                            <span class="step-text">Viele einzelne Websites durchsuchen</span>
                                        </li>
                                        <li class="stepper-item">
                                            <span class="step-circle bg-success"><i class="fa fa-address-book"></i></span>
                                            <span class="step-text">Kontakte sammeln</span>
                                        </li>
                                        <li class="stepper-item">
                                            <span class="step-circle bg-info"><i class="fa fa-linkedin"></i></span>
                                            <span class="step-text">LinkedIn-Profile suchen</span>
                                        </li>
                                        <li class="stepper-item">
                                            <span class="step-circle bg-warning"><i class="fa fa-copy"></i></span>
                                            <span class="step-text">Adressen abgleichen</span>
                                        </li>
                                    </ul>
                                </div>
                                <p class="mb-0 text-danger" style="font-size:1.06rem;">
                                    Das kostet nicht nur wertvolle Zeit, sondern oft auch bares Geld – und die Daten sind häufig lückenhaft oder gar falsch.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- User Questions im Chat Bubble-Style -->
        <div class="row justify-content-center mb-5">
            <div class="col-lg-7">
                <div class="d-flex flex-column gap-3">
                    <div class="chat-bubble-user align-self-start">
                        <i class="fa fa-question-circle text-primary me-2"></i>
                        „Wo finde ich aktuelle E-Mail-Adressen von Entscheidern?“
                    </div>
                    <div class="chat-bubble-user align-self-start">
                        <i class="fa fa-question-circle text-primary me-2"></i>
                        „Gibt es eine Liste von Unternehmen mit Social-Media-Profilen in meiner Zielbranche?“
                    </div>
                    <div class="chat-bubble-user align-self-start">
                        <i class="fa fa-question-circle text-primary me-2"></i>
                        „Wie kann ich gezielt nach Bundesland oder Branche filtern?“
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>